import React, { useState, useEffect, useRef } from "react";
import Dropdown from "./Dropdown";
import Swal from "sweetalert2";
// import FormInputs from "../StudentRegistration/FormInputs";
import FormInputs from "./FormInputs";
import { fetchCourseData } from "../../Redux/StudentRegistration/courseSlice";
import "./scheduletest.css";
import { useDispatch, useSelector } from "react-redux";
import { FULL_API_BASE_URL } from "../../Config/Config";

function ScheduleTest(dataClient) {
  const dispatch = useDispatch();
  const { coursesdata } = useSelector((state) => state.course);
  const [courseOpted, setCourseOpted] = useState("");
  const [batchDataByCourseID, setBatchDataByCourseID] = useState("");
  const [testSeriesData, setTestSeriesData] = useState("");
  const [isOpen, setIsOpen] = useState(true);
  const [assessments, setAssessments] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [selectedAssessment, setSelectedAssessment] = useState(null);
  const filterRef = useRef(null);
  const [values, setValues] = useState({
    course_id: "",
    testseries_id: "",
    batch_id: "",
    start_time: "",
    end_time: "",
  });

  const [isChecked, setIsChecked] = useState(true);
  const clientBranchId =
    dataClient.dataClient?.client_schema_name[6][0].client_branch_id;
  const userName = dataClient.dataClient?.client_schema_name[6][0].user_name;
  const assessment_type_id = 2;
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setSearchKey("");
    dispatch(fetchCourseData());
    // Reset start_time and end_time when courseOpted changes
    setValues((prevValues) => ({
      ...prevValues,
      start_time: "",
      end_time: "",
    }));
  }, [courseOpted, dispatch]);

  useEffect(() => {
    const fetchBatchData = async () => {
      if (courseOpted) {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-batch-name-by-course-id/?course_id=${courseOpted}`
        );
        const data = await response.json();
        setBatchDataByCourseID(data);
      }
    };
    fetchBatchData();
  }, [courseOpted]);

  useEffect(() => {
    setSearchKey("");
    const fetchTestData = async () => {
      if (courseOpted) {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-test-series-list-active/?course_id=${courseOpted}`
        );
        const data = await response.json();
        setTestSeriesData(data);
      }
    };
    fetchTestData();
  }, [courseOpted]);

  useEffect(() => {
    if (searchKey.trim().length === 0) {
      setAssessments([]);
    } else {
      fetchData();
    }
  }, [searchKey]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (filterRef.current && !filterRef.current.contains(event.target)) {
      setAssessments([]);
    }
  };

  const fetchData = async () => {
    const response = await fetch(
      `${FULL_API_BASE_URL}/get-assessment-names/?assessment_type_id=${assessment_type_id}&course_id=${values.course_id}&client_branch_id=${clientBranchId}&search_key=${searchKey}`
    );
    const data = await response.json();

    if (data.data && data.data.length > 0) {
      setAssessments(data.data);
    } else {
      setAssessments([]);
      if (!isInitialLoad) {
        console.log("No tests found for the selected course and test series.");
      }
    }
    setIsInitialLoad(false);
  };

  const handleChange = (e) => {
    setSearchKey(e.target.value);
  };

  const handleAssessmentClick = (item) => {
    setSelectedAssessment(item);
  };

  const handleCancel = () => {
    Swal.fire({
      title: "Are you sure you want to cancel?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: "rgb(100 101 101)",
      cancelButtonColor: "#318682",
    }).then((result) => {
      if (result.isConfirmed) {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    });
  };

  const handleSave = async () => {
    const { batch_id, start_time, end_time } = values;

    if (!selectedAssessment || !batch_id || !start_time || !end_time) {
      Swal.fire({
        title: "Error",
        text: "Please fill all details for scheduling test.",
        icon: "error",
        confirmButtonColor: "rgb(100 101 101)",
      });
      return;
    }

    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/assign-test-to-batch?assessment_id=${
          selectedAssessment.assessment_id
        }&batch_id=${batch_id}&open_datetime=${encodeURIComponent(
          start_time
        )}&close_datetime=${encodeURIComponent(
          end_time
        )}&user_name=${userName}`,

        {
          method: "POST",
        }
      );

      const result = await response.json();
      if (result.message === "Test(s) assigned successfully") {
        Swal.fire({
          title: "Success",
          text: "Test(s) assigned successfully",
          icon: "success",
          confirmButtonColor: "rgb(100 101 101)",
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        throw new Error(result.message || "Error assigning test(s)");
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: `Error assigning test(s): ${error.message}`,
        icon: "error",
        confirmButtonColor: "rgb(100 101 101)",
      });
    }
  };

  const handleStartTimeChange = (e) => {
    const startTime = e.target.value;
    setValues((prevValues) => ({
      ...prevValues,
      start_time: startTime,
    }));

    if (selectedAssessment && selectedAssessment.duration_mins) {
      const duration = selectedAssessment.duration_mins * 60 * 1000; // duration in milliseconds
      const startDate = new Date(startTime);

      // Calculate the end date in UTC
      const endDateUTC = new Date(startDate.getTime() + duration);

      // Convert the end date to IST
      const ISTOffset = 5 * 60 * 60 * 1000 + 30 * 60 * 1000; // IST offset is +5:30
      const endDateIST = new Date(endDateUTC.getTime() + ISTOffset);

      // Format end date to 'YYYY-MM-DDTHH:MM' in IST
      const formattedEndDateIST = endDateIST.toISOString().slice(0, 16);
      setValues((prevValues) => ({
        ...prevValues,
        end_time: formattedEndDateIST,
      }));
    }
  };

  const handleStartNow = () => {
    if (!selectedAssessment || !selectedAssessment.duration_mins) {
      Swal.fire({
        title: "Error",
        text: "No assessment selected or assessment duration not set.",
        icon: "error",
        confirmButtonColor: "rgb(100 101 101)",
      });
      return;
    }

    // Get the current date and time in UTC
    const currentDateUTC = new Date();

    // Convert current date and time to IST
    const ISTOffset = 5 * 60 * 60 * 1000 + 30 * 60 * 1000; // IST offset is +5:30
    const currentDateIST = new Date(currentDateUTC.getTime() + ISTOffset);

    // Format the current date and time to 'YYYY-MM-DDTHH:MM' for input[type="datetime-local"]
    const formattedCurrentDateIST = currentDateIST.toISOString().slice(0, 16);

    // Calculate the end date and time based on the duration of the selected assessment
    let formattedEndDateIST = "";
    if (selectedAssessment && selectedAssessment.duration_mins) {
      const duration = selectedAssessment.duration_mins * 60 * 1000; // duration in milliseconds
      const endDateUTC = new Date(currentDateUTC.getTime() + duration);

      // Convert the end date to IST
      const endDateIST = new Date(endDateUTC.getTime() + ISTOffset);

      // Format the end date to 'YYYY-MM-DDTHH:MM' for input[type="datetime-local"]
      formattedEndDateIST = endDateIST.toISOString().slice(0, 16);
    }
    // Set both start and end date times
    setValues((prevValues) => ({
      ...prevValues,
      start_time: formattedCurrentDateIST,
      end_time: formattedEndDateIST,
    }));
  };

  const filteredAssessments = isChecked
    ? assessments.filter((assessment) => !assessment.assignment_date)
    : assessments;

  return (
    <div className="create-role-container">
      <div className="create-role-container-one">
        <span className="create-role-heading">Assign And Schedule Test</span>
        <div className="cr-header-btn-container">
          <button className="cr-cancel-btn" onClick={handleCancel}>
            CANCEL
          </button>
          <button className="cr-create-btn" onClick={handleSave}>
            SAVE
          </button>
        </div>
      </div>
      <div className="personal-info">
        <div className="personal-header">
          <div className="header">
            <label>Assign Test</label>
          </div>
          <div className="accordion-btn" onClick={toggleAccordion}>
            {isOpen ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isOpen && (
          <div className="accordion-content">
            <div className="select-assign-test-container">
              <div className="grid-container-asssing-test">
                <div className="item1">
                  <Dropdown
                    label="Course"
                    setSelected={(selectedOption) => {
                      setCourseOpted(selectedOption);
                      setValues((prevValues) => ({
                        ...prevValues,
                        course_id: selectedOption,
                        testseries_id: "",
                        batch_id: "",
                      }));
                    }}
                    options={
                      coursesdata
                        ? coursesdata.map((course) => ({
                            label: course.course_description,
                            id: course.course_id,
                          }))
                        : ""
                    }
                  />
                </div>
                <div className="item2">
                  <Dropdown
                    key={`testseries-dropdown-${values.course_id}`}
                    label="Test Series"
                    setSelected={(selectedOption) =>
                      setValues({ ...values, testseries_id: selectedOption })
                    }
                    options={
                      testSeriesData && testSeriesData.test_series
                        ? testSeriesData.test_series.map((series) => ({
                            label: series.ts_name,
                            id: series.ts_id,
                          }))
                        : []
                    }
                    Height="auto"
                    OverFlow="auto"
                    minheight="300px"
                  />
                </div>
              </div>
            </div>
            <div className="filter-with-checkbox">
              <div className="filter-search-test">
                <input
                  type="text"
                  value={searchKey}
                  onChange={handleChange}
                  placeholder="Search Test"
                />
              </div>
              <div className="check-box-not-assign-test">
                <input
                  type="checkbox"
                  className="check-box-not-assing-input"
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                />
                <label>Show tests that are not assigned</label>
              </div>
            </div>
            <div className="assign-test-table">
              <table>
                <thead>
                  <tr>
                    <th>Test Name:</th>
                    <th>Course Name:</th>
                    <th>Subject Name:</th>
                    <th>Batch Name:</th>
                    <th>Assignment Date:</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredAssessments.map((assessment, index) => (
                    <tr
                      key={index}
                      onClick={() => handleAssessmentClick(assessment)}
                      style={{
                        backgroundColor:
                          selectedAssessment &&
                          selectedAssessment.assessment_name ===
                            assessment.assessment_name
                            ? "#f0f8ff"
                            : "",
                      }}
                    >
                      <td>{assessment.assessment_name}</td>
                      <td>{assessment.course_name}</td>
                      <td>{assessment.subject_name}</td>
                      <td>{assessment.batch_name}</td>
                      <td>{assessment.assignment_date}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      <div className="personal-info">
        <div className="personal-header">
          <div className="header">
            <label>Schedule Test</label>
          </div>
        </div>
        <div className="accordion-content">
          <div className="select-assign-test-container">
            <div className="grid-container-schedule-test">
              <div className="item1">
                <Dropdown
                  key={`batch-dropdown-${values.course_id}`}
                  label="Batch"
                  setSelected={(selectedOption) =>
                    setValues({ ...values, batch_id: selectedOption })
                  }
                  options={
                    batchDataByCourseID && Array.isArray(batchDataByCourseID[0])
                      ? batchDataByCourseID[0].map((batch) => ({
                          label: batch.batch_name,
                          id: batch.batch_id,
                        }))
                      : []
                  }
                  Height="auto"
                  OverFlow="auto"
                  minheight="300px"
                />
              </div>
              <div className="item2">
                <FormInputs
                  label="Start/Live date and time"
                  type="datetime-local"
                  value={values.start_time}
                  onChange={handleStartTimeChange}
                />
              </div>
              <div className="item3">
                <FormInputs
                  label="End date and time"
                  type="datetime-local"
                  value={values.end_time}
                  readOnly
                />
              </div>
              <div className="item-4">
                <button onClick={handleStartNow}>Start Now</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ScheduleTest;
